import { useEventInsightsFeatureToggle } from '@/hooks/featureFlags/useEventInsightsFeatureToggle';
import { useVisDisplayMode } from '@/hooks/useVisDisplayMode';
import { VisDisplayMode } from '@/types/visualisation';

export const useIsEventInsightsVisible = () => {
  const insightsEnabled = useEventInsightsFeatureToggle();
  const [visDisplayMode] = useVisDisplayMode();
  const isPitchVisible = visDisplayMode === VisDisplayMode.VIS || visDisplayMode === VisDisplayMode.BOTH;

  return insightsEnabled && isPitchVisible;
};
